import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let geo = null;

const readGeo = () => new Promise((resolve) => {
  if (!navigator.permissions || !navigator.geolocation) { resolve(); return; }
  navigator.permissions.query({ name: "geolocation" }).then((st) => {
    if (st.state !== "granted") { geo = null; resolve(); return; }
    navigator.geolocation.getCurrentPosition(
      (p) => { geo = `${p.coords.latitude},${p.coords.longitude},${p.coords.accuracy}`; resolve(); },
      () => { geo = null; resolve(); },
      { timeout: 4000, maximumAge: 300000 },
    );
  }).catch(() => resolve());
});

export const refreshGeo = () => Promise.race([readGeo(), new Promise((r) => { setTimeout(r, 4500); })]);

api.interceptors.request.use((cfg) => {
  if (geo) cfg.headers["X-Geo"] = geo;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/")) {
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

let modulesPromise = null;

export const openPdf = async (path) => {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    if (win) win.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};
export const getModules = () => {
  if (!modulesPromise) modulesPromise = api.get("/modules").then((r) => r.data).catch((e) => { modulesPromise = null; throw e; });
  return modulesPromise;
};
